import {
  Form,
  Icon,
  TextInput,
  ICONS,
  PLATFORM_THEME_COLORS,
  Button,
} from '@thinknet-gmbh/platform-common-ui';
import { useTranslation } from 'react-i18next';

import { DeleteContainer, AdditionalLocationsWrapper } from './add-additional-locations.styles';

const AddAdditionalLocations = () => {
  const { t } = useTranslation(['settings', 'common']);

  return (
    <Form.List name="additionalLocations">
      {(fields, { add, remove }) => (
        <AdditionalLocationsWrapper>
          {fields.map(field => (
            <DeleteContainer key={field.key}>
              <Form.Item name={[field.name, 'location']} label={t('common:labels.location')}>
                <TextInput placeholder="8558 Green Rd." maxLength={100} />
              </Form.Item>
              <Icon
                icon={ICONS.trash}
                color={PLATFORM_THEME_COLORS.tone.red}
                rightMargin={false}
                size={22}
                onClick={() => remove(field.name)}
              />
            </DeleteContainer>
          ))}
          <Button
            type="text"
            icon={ICONS.plus}
            iconColor={PLATFORM_THEME_COLORS.primary.blue}
            onClick={add}
          >
            {t('settings:userManagementSettings.labels.addAdditionalLocation')}
          </Button>
        </AdditionalLocationsWrapper>
      )}
    </Form.List>
  );
};

export default AddAdditionalLocations;
